export default "__VITE_ASSET__BcXjkxm8__"